import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Tajawal, Arial, sans-serif',
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Tajawal, Arial, sans-serif',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#0f3662',
    },
    secondary: {
      main: '#a72c2a',
    },
  },
});

export default theme;